import React from "react"
import ReactDOM from "react-dom"
import ReactGA from "react-ga"
import "./font.css"
import "./index.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { requestAnonymousTokenAsync } from "./utils/api/PopTokenGenerator"

ReactGA.initialize(process.env.REACT_APP_TRACKING_ID)

// Fetch the anonymous (guest) token immediately on startup so it is stored
// in sessionStorage before any page API calls fire. Not awaited — React renders
// in parallel and the token is typically ready well before the first request.
requestAnonymousTokenAsync();

ReactDOM.render(<App />, document.getElementById("root"))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
